require('./brokerCashChargeStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKInput } = require('commonsComponents/OKInput');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    BROKE_CASH_CHARGE_STEP1_SANTANDER_BANK_LABEL,
    BROKE_CASH_CHARGE_STEP1_SANTANDER_BANK_URL
} = require('constants/index');
const CLASS_NAME = 'broker-cash-charge-step1';

class BrokerCashChargeStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleTitlesAmountChange = this.handleTitlesAmountChange.bind(this);
    }

    handleTitlesAmountChange(event) {
        this.props.onChangeTitlesAmount(event.target.value);
    }

    render() {
        const {
            immBrokerCashCharge,
            onChangeAcceptedInstructions,
            actions,
            cancelButton,
            nextButton
        } = this.props;
        const immFirstStep = immBrokerCashCharge.getIn(['steps', FIRST_STEP]);
        const titlesAmountLabel = formatText('cashCharge-titlesAmount');
        const titlesAmount = immFirstStep.get('titlesAmount');
        const acceptInstructionsLabel = formatText('cashCharge-readAndAcceptInstructions');
        const acceptedInstructions = immFirstStep.get('acceptedInstructions');

        return (
            <WizardStep
                actions={actions}
                cancelButton={cancelButton}
                nextButton={nextButton}
                position="first"
            >
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText
                        value="cashCharge-cashChargeInformation"
                    />
                </h4>
                <div className={`${CLASS_NAME}__info`}>
                    <FormattedText
                        value="cashCharge-specifyTitles"
                    />
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    <div className={`${CLASS_NAME}__input`}>
                        <OKInput
                            label={titlesAmountLabel}
                            value={titlesAmount}
                            onChange={this.handleTitlesAmountChange}
                        />
                    </div>
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    <h4 className={`${CLASS_NAME}__title`}>
                        <FormattedText value="cashCharge-clause"/>
                    </h4>
                    <p>
                        <FormattedText value="cashCharge-clause1"/>
                        {' '}
                        <OKLink modifier="emphasize" to={BROKE_CASH_CHARGE_STEP1_SANTANDER_BANK_URL}>
                            {BROKE_CASH_CHARGE_STEP1_SANTANDER_BANK_LABEL}
                        </OKLink>
                        {' '}
                        <FormattedText value="cashCharge-clause2"/>
                    </p>
                    <p><FormattedText value="cashCharge-clause3"/></p>
                    <p><FormattedText value="cashCharge-clause4"/></p>
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    <OKCheckbox
                        idName="instructionsCheckbox"
                        label={acceptInstructionsLabel}
                        value={acceptedInstructions}
                        onChange={onChangeAcceptedInstructions}
                    />
                </div>
            </WizardStep>
        );
    }
}

BrokerCashChargeStep1.propTypes = {
    immBrokerCashCharge: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    onChangeAcceptedInstructions: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerCashChargeStep1.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerCashChargeStep1;